import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';
import { NpsDismissalReason } from '@swf/core/models/nps';
import type { Dispatch } from '@swf/core/store';

interface Props {
  timeout: number;
  resetOnInteraction?: boolean;
}
const Expire: React.FC<Props> = ({ timeout, resetOnInteraction = false, children }) => {
  const dismissalUrl = useResolver(ResolverTag.NPSDismissal);
  const [display, setDisplay] = useState(true);
  const [hover, setHover] = useState(false);
  const expirationTimer = useRef<number>();
  const dispatch = useDispatch<Dispatch>();

  useEffect(() => {
    const stopTimer = () => window.clearTimeout(expirationTimer.current);
    stopTimer();
    if (!hover) {
      expirationTimer.current = window.setTimeout(() => {
        setDisplay(false);
        dispatch.nps.dismiss({ dismissalUrl, dismissalReason: NpsDismissalReason.AutoDismissed });
      }, timeout);
    }
    return stopTimer;
  }, [timeout, hover, dispatch.nps, dismissalUrl]);

  if (!display) return null;

  const show = () => setHover(true);
  const hide = () => setHover(false);

  return (
    <div
      onMouseEnter={resetOnInteraction ? show : undefined}
      onMouseLeave={resetOnInteraction ? hide : undefined}
      onFocus={resetOnInteraction ? show : undefined}
      onBlur={resetOnInteraction ? hide : undefined}
    >
      {children}
    </div>
  );
};

export default Expire;
